<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    /><path
      d="M12.375 16.238a1.906 1.906 0 10-1.844-1.9 1.875 1.875 0 001.844 1.9zm5.531-8.571h-.922v-1.9A4.689 4.689 0 0012.375 1a4.689 4.689 0 00-4.61 4.762h1.752a2.859 2.859 0 115.716 0v1.9H6.844A1.875 1.875 0 005 9.571V19.1A1.875 1.875 0 006.844 21h11.063a1.875 1.875 0 001.844-1.9V9.571a1.875 1.875 0 00-1.844-1.904zm0 11.429H6.844V9.571h11.063z"
      fill="currentColor"
    />
  </g>
</template>